/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalConfiguration
 */
export interface GlobalConfiguration {
    /**
     * 
     * @type {Date}
     * @memberof GlobalConfiguration
     */
    licenseExpiration: Date;
}

/**
 * Check if a given object implements the GlobalConfiguration interface.
 */
export function instanceOfGlobalConfiguration(value: object): value is GlobalConfiguration {
    if (!('licenseExpiration' in value) || value['licenseExpiration'] === undefined) return false;
    return true;
}

export function GlobalConfigurationFromJSON(json: any): GlobalConfiguration {
    return GlobalConfigurationFromJSONTyped(json, false);
}

export function GlobalConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'licenseExpiration': (new Date(json['licenseExpiration'])),
    };
}

export function GlobalConfigurationToJSON(value?: GlobalConfiguration | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'licenseExpiration': ((value['licenseExpiration']).toISOString()),
    };
}

